import dayjs from "dayjs";
import "dayjs/locale/cs";
dayjs.locale("cs");

/**
 * Returns an object containing the dayjs library instance.
 *
 * @return {Object} The dayjs library instance
 */
export function useDayjs() {
    return {
        dayjs,
    };
}
